module.exports = __webpack_public_path__ + "static/media/dzinelab.58c0e953.png";